import CurrencyRates from '../../../../components/editable-cell/form-items/currency-rate'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const currencyRateColumn: CalculationColumn = {
    dataIndex: 'currencyRate',
    title: 'Курс',
    width: 40,
    editable: true,
    FormItem: <CurrencyRates />,
    onCell: onAnyStandardCell,
}
